import { useEffect, useMemo, useState, useRef } from "react";
import TCPlayerComponent from "../components/TCPlayer";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import LoginModal from "./LoginModal";
import Footer from "./Footer";
import Header from "./Header";
import FullScreenLoader from "../components/fullScreenLoader";
import ChatPage from "../components/Chat";
import Cookies from "js-cookie";
import { initTim } from "../lib/timInstance";
import { cn } from "../lib/utils";
import Swal from "sweetalert2";

export type UserData = {
  imsdkAppID: string;
  account: string;
  imSign: string;
  imGroupId: string;
};

export default function J88Homepage() {
  const activityList = [
    {
      name: "XEM LIVE THẢ GA - NHẬN QUÀ CỰC ĐÃ",
      imgUrl: `${process.env.PUBLIC_URL}/img/activity.png`,
    },
    {
      name: "XEM LIVE THẢ GA - NHẬN QUÀ CỰC ĐÃ",
      imgUrl: `${process.env.PUBLIC_URL}/img/activity2.png`,
    },
  ];
  const [liveStreamUrl, setLiveStreamUrl] = useState("");
  const [advertiseVideoUrl, setAdvertiseVideoUrl] = useState("");
  const [fallbackUrl, setFallBackUrl] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [onlineNumber, setOnlineNumber] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [minutes, setMinutes] = useState(0);
  const [minutesLoaded, setMinutesLoaded] = useState(false);

  // Ref for fetchLiveStreamInfo so it can be used in polling
  const fetchLiveStreamInfoRef =
    useRef<() => Promise<void> | undefined>(undefined);

  useEffect(() => {
    const cookie = Cookies.get("user");
    if (cookie) {
      setUser(JSON.parse(cookie));
    }
  }, [Cookies.get("user")]);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const configRes = await fetch(`${process.env.PUBLIC_URL}/config.json`);
        const config = await configRes.json();
        setMinutes(config.checkByMinutes);
        setMinutesLoaded(true);
        if (config.videoUrl.includes("http")) {
          setFallBackUrl(config.videoUrl);
        } else {
          setFallBackUrl(`${process.env.PUBLIC_URL}${config.videoUrl}`);
        }
      } catch (error) {
        console.error("Failed to load config.json", error);
      }
    };

    fetchConfig();
  }, []);

  const tim = useMemo(
    () => user?.imsdkAppID && initTim(user.imsdkAppID),
    [user?.imsdkAppID]
  );

  // --- Main effect for initial fetch and polling ---
  useEffect(() => {
    let pollingIntervalId: NodeJS.Timeout;
    let delayTimeoutId: NodeJS.Timeout;
    let retryIntervalId: NodeJS.Timeout;

    const fetchLiveStreamInfo = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/LiveStream/GetLivePlan?apikey=${process.env.REACT_APP_API_KEY}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const liveStreamInfo = await res.json();

        if (liveStreamInfo.data) {
          const now = new Date().getTime();
          const streamStart = new Date(liveStreamInfo.data.startTime).getTime();

          if (now >= streamStart) {
            setLiveStreamUrl((prevUrl) => {
              if (liveStreamInfo.data.playAddress !== prevUrl) {
                return liveStreamInfo.data.playAddress;
              }
              return prevUrl;
            });
          } else {
            // Not yet time, clear the livestream and wait
            setLiveStreamUrl("");
          }

          setAdvertiseVideoUrl((prevAdUrl) => {
            if (liveStreamInfo.data.advertiseVideoUrl !== prevAdUrl) {
              return liveStreamInfo.data.advertiseVideoUrl;
            }
            return prevAdUrl;
          });

          setAdvertiseVideoUrl((prevAdUrl) => {
            if (liveStreamInfo.data.advertiseVideoUrl !== prevAdUrl) {
              return liveStreamInfo.data.advertiseVideoUrl;
            }
            return prevAdUrl;
          });

          setStartTime(liveStreamInfo.data.startTime);
          setEndTime(liveStreamInfo.data.endTime);

          if (retryIntervalId) clearInterval(retryIntervalId);
        } else {
          // If no data, retry every minute
          if (!retryIntervalId && minutesLoaded && minutes > 0) {
            retryIntervalId = setInterval(fetchLiveStreamInfo, minutes);
          }
        }
      } catch (err) {
        Swal.fire({
          title: "THẤT BẠI",
          text: "Không thể lấy thông tin phát sóng trực tiếp",
          icon: "error",
          confirmButtonText: "Xác nhận",
          confirmButtonColor: "red",
        });
      }
    };

    // Save reference for polling effect
    fetchLiveStreamInfoRef.current = fetchLiveStreamInfo;

    const fetchOnlineInfo = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/LiveStream/GetOnLine?apikey=${process.env.REACT_APP_API_KEY}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const onlineInfo = await res.json();
        if (onlineInfo?.data !== undefined) {
          setOnlineNumber(onlineInfo.data);
        }
      } catch (err) {
        Swal.fire({
          title: "THẤT BẠI",
          text: "Không thể lấy thông tin số trực tuyến",
          icon: "error",
          confirmButtonText: "Xác nhận",
          confirmButtonColor: "red",
        });
      }
    };

    const startPolling = () => {
      pollingIntervalId = setInterval(() => {
        fetchOnlineInfo();
      }, 10000);
    };

    const scheduleFetch = async () => {
      setLoading(true);

      await fetchLiveStreamInfo();
      await fetchOnlineInfo();

      if (startTime) {
        const now = Date.now();
        const targetTime = new Date(startTime).getTime();
        const delay = targetTime - now;

        if (delay <= 0) {
          await fetchLiveStreamInfo();
          startPolling();
        } else {
          delayTimeoutId = setTimeout(async () => {
            await fetchLiveStreamInfo();
            startPolling();
          }, delay);
        }
      }

      if (endTime) {
        const now = Date.now();
        const targetTime = new Date(endTime).getTime();
        const delay = targetTime - now;

        if (delay <= 0) {
          await fetchLiveStreamInfo();
          startPolling();
        } else {
          delayTimeoutId = setTimeout(async () => {
            await fetchLiveStreamInfo();
            startPolling();
          }, delay);
        }
      }

      setLoading(false);
    };

    scheduleFetch();

    return () => {
      clearInterval(pollingIntervalId);
      clearTimeout(delayTimeoutId);
      clearInterval(retryIntervalId);
    };
  }, [startTime, endTime, minutesLoaded, minutes]);

  // --- Dedicated minute polling effect ---
  useEffect(() => {
    if (!minutesLoaded || !liveStreamUrl || !minutes || minutes <= 0) return;

    const minutePolling = setInterval(() => {
      if (fetchLiveStreamInfoRef.current) {
        fetchLiveStreamInfoRef.current();
      }
    }, minutes);

    return () => {
      clearInterval(minutePolling);
    };
  }, [minutesLoaded, liveStreamUrl, minutes]);

  // ...rest of your component unchanged...
  const eyes_icon = () => (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 576 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path>
    </svg>
  );

  const share_icon = () => (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"></path>
    </svg>
  );

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Check out this video!",
          text: "Watch this awesome clip",
          url: window.location.href,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing not supported on this browser.");
    }
  };

  return (
    <div className="bg-white text-black min-h-screen font-sans">
      {loading && <FullScreenLoader />}
      {/* Top Bar + Navigation */}
      <Header
        tim={tim}
        user={user}
        setUser={setUser}
        setShowLoginModal={setShowLoginModal}
      />

      {/* Main Content */}
      <div className=" flex flex-col justify-center items-center lg:px-12 xl:px-28 2xl:px-[400px] gap-y-3">
        <section className="flex flex-col w-full justify-center gap-y-3 my-5 mx-4 gap-x-3">
          <div className="hidden lg:flex flex-col lg:flex-row items-end justify-center gap-2 w-full">
            <div className="w-full lg:w-3/4 ">
              <a
                href="https://cpqtr.ink/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/banner.jpg`}
                  alt="Banner"
                  className="w-full h-auto rounded-lg object-cover"
                />
              </a>
            </div>
            <div className="w-full lg:w-1/4">
              <a
                href="https://j88x5y.vip/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/downloadApp.png`}
                  alt="button"
                  className="w-full h-auto object-cover xl:w-[400px] 2xl:w-[450px]"
                />
              </a>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-y-2 gap-x-2 h-full justify-center">
            <div className="w-full lg:w-3/4  bg-black rounded-t-lg">
              <div className="bg-[#EB0000]/70 flex rounded-t-lg text-white p-4 justify-between items-center text-xs sm:text-sm md:text-base">
                <div className="flex flex-col ">
                  <span className="font-bold text-black/60">
                    Giới thiệu về kênh livestream J88
                  </span>
                  <div className="flex flex-row gap-x-3">
                    <span className="font-bold text-xs md:text-sm flex items-center">
                      Admin J88
                    </span>
                    <span className="text-xs md:text-sm flex flex-row gap-x-1 items-center">
                      {eyes_icon()}
                      {onlineNumber || 0}
                    </span>
                  </div>
                </div>
                <button
                  className="flex gap-x-3 bg-black/60 rounded-full p-2 items-center whitespace-nowrap"
                  onClick={handleShare}
                >
                  {share_icon()}
                  Chia sẻ
                </button>
              </div>
              {!loading && (
                <TCPlayerComponent
                  videoUrl={liveStreamUrl}
                  advertiseVideoUrl={advertiseVideoUrl}
                  fallbackUrl={fallbackUrl}
                  setStartTime={setStartTime}
                  setEndTime={setEndTime}
                />
              )}
            </div>
            <div className=" lg:w-1/4 lg:px-0 px-3">
              <div className="min-h-[300px] 2xl:h-full bg-white border w-full h-full rounded-lg shadow flex flex-col justify-between">
                <div>
                  <div className="flex w-full">
                    <div className="flex-1 text-sm text-center font-semibold py-2 rounded-t-lg bg-[#EB0000] text-white ">
                      Bình Luận
                    </div>
                  </div>
                  <div
                    className="bg-white text-red-500 p-3 pb-1 rounded-md cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <div className="flex items-start space-x-3">
                      <div className="bg-white/30 rounded-full"></div>
                      <p
                        className={`text-xs transition-all duration-300 ${
                          isOpen ? "line-clamp-none" : "line-clamp-1"
                        }`}
                      >
                        <span className="text-red font-semibold ">
                          🔔 ADMIN J88:
                        </span>{" "}
                        Chào mừng bạn đến với phòng Live J88. Tại đây Admin
                        thiết lập môi trường thân thiện hài hòa. Tất cả nội dung
                        lạm dụng, thô tục và nhạy cảm sẽ bị chặn. Hội viên chú ý
                        giữ an toàn tài sản của bạn vui lòng không chuyển tiền
                        riêng để tránh bị lừa đảo.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={cn(
                    "w-full h-[220px] lg:h-full",
                    isOpen
                      ? "lg:max-h-[370px] xl:max-h-[410px] lg:h-[370px] xl:h-[410px] height-2k"
                      : " lg:max-h-[480px] xl:max-h-[510px] lg:h-[480px] xl:h-[510px] height"
                  )}
                >
                  {user ? (
                    <ChatPage
                      tim={tim}
                      setShowLoginModal={setShowLoginModal}
                      user={user}
                      setUser={setUser}
                      startTime={startTime}
                      endTime={endTime}
                    />
                  ) : (
                    <div className=" rounded-b-lg flex flex-1 items-end justify-center h-full w-full bg-black/80 pb-4 z-10">
                      <button
                        onClick={() => setShowLoginModal(true)}
                        className="text-white bg-[#EB0000] hover:bg-red-700 px-4 py-2 rounded-full text-sm font-medium"
                      >
                        Đăng Nhập
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="flex flex-col w-full justify-center mb-6 p-3 lg:p-0">
          <div className="rounded-lg shadow-md">
            <div className="text-center w-full text-white text-lg font-bold bg-[#EB0000] rounded-t-lg py-2">
              TIN TỨC
            </div>
            {/*Desktop view */}
            <div className="hidden lg:flex w-full gap-x-4">
              <div className="flex flex-col gap-y-2">
                {activityList.map((activity, index) => (
                  <div
                    key={index}
                    onClick={() => setSelectedIndex(index)}
                    className={`text-[14px] pt-2 pl-2 font-bold h-fit cursor-pointer border-l-2 transition-colors duration-200 ${
                      selectedIndex === index
                        ? "text-[#EB0000] border-[#EB0000]"
                        : "text-[#919191] border-transparent"
                    }`}
                  >
                    {activity.name}
                  </div>
                ))}
              </div>
              <div className="w-full rounded-lg shadow">
                <img
                  src={activityList[selectedIndex].imgUrl}
                  alt="activity"
                  className="rounded-br-lg w-full h-auto object-cover"
                />
              </div>
            </div>
            {/* Mobile view */}
            <div className="block lg:hidden">
              <Swiper
                spaceBetween={16}
                pagination={{ clickable: true }}
                modules={[Pagination]}
              >
                {activityList.map((activity, index) => (
                  <SwiperSlide key={index}>
                    <div className="rounded-lg overflow-hidden shadow-md pb-6">
                      <div className="text-[14px] text-center font-bold py-2 text-[#EB0000] bg-white">
                        {activity.name}
                      </div>
                      <img
                        src={activity.imgUrl}
                        alt={activity.name}
                        className="w-full h-auto object-cover"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section>
        {/* Login Modal */}
        {showLoginModal && (
          <LoginModal
            setShowLoginModal={setShowLoginModal}
            setLoading={setLoading}
            setUser={setUser}
          />
        )}
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
